export async function getBase64FileContents(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      if (!event.target) {
        reject(
          new Error("File reader event does not have a target reader object")
        );
        return;
      }

      const dataUrl = event.target.result;

      if (dataUrl == null) {
        reject(new Error("No data url returned from file"));
        return;
      }

      if (typeof dataUrl !== "string") {
        reject(new Error("Data url is not a string"));
        return;
      }

      const base64 = dataUrl.split(",")[1];
      resolve(base64);
    };

    reader.onerror = (event) => {
      reject(
        event.target?.error ||
          new Error(
            "Encountered an unknown error while trying to read the file"
          )
      );
    };

    reader.readAsDataURL(file);
  });
}
